import React from 'react';
import { Snowflake, Car, Droplet, Toilet, Shirt, ShowerHead, Wifi, Coffee, Lightbulb, ShieldPlus, Umbrella, Camera } from 'lucide-react';
import { AMENITIES_CATALOG, amenityMeta } from './venueAmenities';

const ICONS = { Snowflake, Car, Droplet, Toilet, Shirt, ShowerHead, Wifi, Coffee, Lightbulb, ShieldPlus, Umbrella, Camera };

// شبكة أيقونات الخدمات — تُعرض في تفاصيل الملعب للزائر
export function AmenitiesGrid({ amenityIds }) {
  const items = (amenityIds || []).map(amenityMeta).filter(Boolean);
  if (!items.length) return null;
  return (
    <div>
      <p className="mb-2 flex items-center gap-1.5 text-sm font-bold text-white">
        الخدمات <span className="h-1.5 w-1.5 rounded-full bg-teal-400" />
      </p>
      <div className="flex gap-2.5 overflow-x-auto pb-1 no-scrollbar" data-testid="venue-amenities-grid">
        {items.map((a) => {
          const Ic = ICONS[a.icon];
          return (
            <div key={a.id} className="flex w-14 shrink-0 flex-col items-center gap-1 text-center" data-testid={`venue-amenity-${a.id}`}>
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-white/5 text-teal-300">
                {Ic && <Ic className="h-4 w-4" />}
              </span>
              <span className="text-[10px] leading-tight text-slate-300">{a.label}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

// شبكة اختيار الخدمات (checkbox) — تُستخدم في نموذج إضافة/تعديل الملعب
export function AmenitiesPicker({ selected, onChange, testId }) {
  const toggle = (id) => {
    onChange(selected.includes(id) ? selected.filter((x) => x !== id) : [...selected, id]);
  };
  return (
    <div className="grid grid-cols-2 gap-2 sm:grid-cols-3" data-testid={testId}>
      {AMENITIES_CATALOG.map((a) => {
        const Ic = ICONS[a.icon];
        const active = selected.includes(a.id);
        return (
          <button
            type="button" key={a.id} onClick={() => toggle(a.id)} data-testid={`${testId}-${a.id}`}
            className={`flex items-center gap-1.5 rounded-lg border px-2.5 py-2 text-xs font-semibold transition-colors ${active ? 'border-teal-400 bg-teal-50 text-teal-700' : 'border-slate-200 text-slate-500 hover:bg-slate-50'}`}
          >
            {Ic && <Ic className="h-3.5 w-3.5 shrink-0" />}
            {a.label}
          </button>
        );
      })}
    </div>
  );
}
